import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { MediaLibraryResultsController } from '~components/search/controller/MediaLibraryResultsController';
import useAppSelector from '~hooks/useAppSelector';
import useMediaLibrarySearchResult from '~modules/media-library/context/useMediaLibrarySearchResult';
import useMediaLibrarySettings from '~modules/media-library/context/useMediaLibrarySettings';
import { ViewContext } from '~modules/media-library/model/ViewContext';
import { selectAddonsDefaultLibraryLink } from '~store/selectors';

export function MediaLibraryFavouritesList() {
  const { setViewContext } = useMediaLibrarySettings();

  const { resultCount } = useMediaLibrarySearchResult();

  const defaultLibraryLink = useAppSelector(selectAddonsDefaultLibraryLink);

  useEffect(() => {
    setViewContext(ViewContext.FAVOURITE);
  });

  if (resultCount === 0) {
    return (
      <>
        <br />
        <br />
        <FormattedMessage
          id="msgFavouritesAssetEmpty"
          defaultMessage="No Favourites"
          values={{
            h3: chunks => <h3>{chunks}</h3>,
            a: chunks => <a href={defaultLibraryLink}>{chunks}</a>,
            br: <br />,
          }}
        />
      </>
    );
  }

  return (
    <>
      <MediaLibraryResultsController />
    </>
  );
}
